import {
  Component, OnInit, ViewChild, ElementRef
} from '@angular/core';

import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FileService } from '../../_services/file.service';
import { BrowserModule } from '@angular/platform-browser';

@Component({
  selector: 'request-document-component',
  templateUrl: './request-document.component.html',
  providers:[FileService]
})
export class RequestDocumentComponent implements OnInit {
  /**
   * Our "droppable" node isn't visible all the time.
   * The setter will be called when "droppable" appears or disappears
   **/
  @ViewChild('droppable') set droppable(droppable: ElementRef) {
    if(droppable) {
      this.makeDroppable(droppable.nativeElement, this.onDrop, this);
      this.droppable1=droppable;
    }
  };

  token:string='';
  request:string='pending';
  firstname:string='';
  lastname:string='';
  partner:string='';
  schoolyear:string='';
  attachableType:string='';

  validationMessages: any;
  formErrors:any;
  formSegment:FormGroup;
  subscriptions:any;
  filepath:string;
  filename:string;
  touched:boolean=false;

  droppable1: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private fileService: FileService
  ) {
    this.subscriptions=[];
  }

  onDrop(files, evt, classobject?: any) {
      var lastRequest=classobject.request;
      classobject.touched=true;
      classobject.loading = true;
      classobject.request = 'pending';
      for (let i = 0; i < files.length; i++) {
          let ext = '';
          //console.log(files[i]);
          // Here, we simply log the Array of files to the console.
          let mimeType = files[i].type;
          ext = files[i].name.split('.').pop();
          //console.log(ext);
          const allowedMIMEType = ['application/pdf','image/jpeg','image/x-png','image/png'];
          if(allowedMIMEType.indexOf(mimeType)>= 0 ){
              classobject.filetype = ext;

              const body = {
                  token: classobject.token,
                  file: files[i]
              };

              //console.log(body);

              classobject.subscriptions.push(classobject.fileService.uploadRequestedFile(body).subscribe(

                responsedata => {
                  var parsed=JSON.parse(responsedata._body);
                  classobject.filename=parsed.filename;

                  classobject.loading = false;
                  classobject.request = 'complete';
                },

                error => {
                  console.log('error',error);
                  classobject.loading = false;
                  classobject.request = 'error';
                }

              ));

          } else {
              alert("File not allowed");
              classobject.loading = false;
              classobject.request=lastRequest;
          }
      }
  }

  makeDroppable(element, callback,classObj) {
    var input = document.createElement('input');
    input.setAttribute('type', 'file');
    //input.setAttribute('multiple', 'true');
    input.style.display = 'none';

    input.addEventListener('change', function (e) {
      triggerCallback(e, classObj);
    });
    element.appendChild(input);

    element.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.add('dragover');
    });

    element.addEventListener('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
    });

    element.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
      triggerCallback(e,classObj);
    });

    element.addEventListener('click', function() {
      input.value = null;
      input.click();
      //console.log(input);
    });

    function triggerCallback(e,obj) {
      var files;
      if(e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if(e.target) {
        files = e.target.files;
      }
      callback.call(null,files,e,obj);
    }
  }

  ngOnInit() {
    var init={};
    init['fileId']=new FormControl();
    this.formSegment=new FormGroup(init);

    this.activatedRoute.params.subscribe((params)=>{
      this.token=params.token;
      this.fileService.getFileRequestInfo(this.token).subscribe(
        (result)=>{
          this.firstname=result.firstname;
          this.lastname=result.lastname;
          this.partner=result.partner;
          this.schoolyear=result.schoolyear;
          this.attachableType=result.attachableType;
          this.request='found';
        },
        (err)=>{
          this.request='err';
        }
      );
    })
  }

  ngOnDestroy() {
    var C;
    while(C=this.subscriptions.pop()) {
      C.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/request-document/request-document.component.ts